export default __webpack_public_path__ + "static/media/hired-logo.e2eb4655.svg";